<script lang="ts">
  /** Helligkeitsregler 1–100 % (Touch-freundlich, mit Füllung). */
  let {
    value,
    disabled = false,
    label,
    onchange,
  }: {
    value: number | null;
    disabled?: boolean;
    label: string;
    onchange: (value: number) => void;
  } = $props();

  // Ausgeschaltet (null) steht der Regler links; Ziehen schaltet wieder ein.
  const shown = $derived(value === null ? 1 : Math.max(1, Math.min(100, Math.round(value))));
</script>

<input
  type="range"
  class="dimmer"
  min="1"
  max="100"
  step="1"
  value={shown}
  {disabled}
  aria-label={label}
  aria-valuetext="{shown} %"
  style:--fill="{shown}%"
  oninput={(e) => onchange(Number((e.currentTarget as HTMLInputElement).value))}
/>

<style>
  .dimmer {
    -webkit-appearance: none;
    appearance: none;
    width: 100%;
    height: 32px;
    background: transparent;
    touch-action: pan-y;
  }
  .dimmer::-webkit-slider-runnable-track {
    height: 8px;
    border-radius: var(--r-pill);
    background: linear-gradient(90deg, var(--text) var(--fill), var(--raised-2) var(--fill));
  }
  .dimmer::-moz-range-track {
    height: 8px;
    border-radius: var(--r-pill);
    background: linear-gradient(90deg, var(--text) var(--fill), var(--raised-2) var(--fill));
  }
  .dimmer::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 24px;
    height: 24px;
    margin-top: -8px;
    border-radius: 50%;
    background: #fff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
  }
  .dimmer::-moz-range-thumb {
    width: 24px;
    height: 24px;
    border: 0;
    border-radius: 50%;
    background: #fff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
  }
  .dimmer:disabled {
    opacity: 0.35;
  }
</style>
